
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface WelcomeDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const WelcomeDialog = ({ isOpen, onClose }: WelcomeDialogProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Bem-vindo ao Justiçai!</DialogTitle>
          <DialogDescription>
            Você está usando o plano Gratuito que inclui:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <p className="text-sm font-medium">🔄 3 mensagens por dia</p>
            <p className="text-sm font-medium">💾 10MB de armazenamento</p>
            <p className="text-sm font-medium">📅 1 dia de histórico</p>
          </div>
          <div className="mt-4 space-y-2">
            <p className="text-sm text-muted-foreground">
              Quer mais recursos? Nossos planos pagos oferecem:
            </p>
            <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
              <li>Mensagens ilimitadas</li>
              <li>Maior espaço de armazenamento</li>
              <li>Histórico estendido</li>
              <li>Suporte prioritário</li>
            </ul>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => {
            navigate('/casos');
            onClose();
          }}>
            Continuar com Gratuito
          </Button>
          <Button onClick={() => {
            navigate('/planos');
            onClose();
          }}>
            Ver planos premium
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeDialog;
